import Swiper from "swiper/bundle";
import GOOGLEMAP from "../plugins/googlemap";
import { TweenMax } from "gsap";

const [w, d, host, mq] = [window, document, location.host, window.matchMedia('(max-width: 900px)')];

const apply_movie = () => {
  let player;
  const playerDOM = $('.mainvisual__mov')[0];

  w.onYouTubeIframeAPIReady = () => {
    player = new YT.Player(playerDOM, { // eslint-disable-line no-undef
      height: '100%',
      width: '100%',
      videoId: '3mF6YlN3YEY',
      playerVars: {
        controls: 0,
        rel: 0,
        playsinline: 1,
      },
      events: {
        onReady,
        onStateChange
      }
    });
  }
  const onReady = event => {
    event.target.mute();
    event.target.playVideo();
    player.getIframe().parentElement.classList.add('is-ready');
  }

  // プレーヤーの状態が変更されたとき
  const onStateChange = event => {
    // 現在のプレーヤーの状態を取得
    var ytStatus = event.target.getPlayerState();
    // 再生終了したとき
    if (ytStatus == YT.PlayerState.ENDED) { // eslint-disable-line no-undef
      player.playVideo();
    }
  }
}

/*
カーソルに追従するアニメーション
*/
function CursorFollower(delay_time) {

  const
    cursor = document.querySelector('.js-cursor'),
    chaser = document.querySelector('.js-chaser');
  let
    delay = delay_time,
    cursorPosX = 0,
    cursorPosY = 0,
    chaserPosX = 0,
    chaserPosY = 0;

  // カーソルの遅延アニメーション
  TweenMax.to({}, 0.01, {
    repeat: -1,
    onRepeat() {
      chaserPosX += (cursorPosX - chaserPosX) / delay;
      chaserPosY += (cursorPosY - chaserPosY) / delay;

      TweenMax.set(cursor, {
        css: {
          left: cursorPosX - (cursor.clientWidth / 2),
          top: cursorPosY - (cursor.clientWidth / 2)
        }
      })

      TweenMax.set(chaser, {
        css: {
          left: chaserPosX - (chaser.clientWidth / 2),
          top: chaserPosY - (chaser.clientWidth / 2)
        }
      })
    }
  })

  // マウス座標を取得
  document.onmousemove = event => {
    cursorPosX = event.pageX;
    cursorPosY = event.pageY;
  }

  $("a,button").on({
    mouseenter() {
      cursor.classList.add("is-active")
      chaser.classList.add("is-active")
    },
    mouseleave() {
      cursor.classList.remove("is-active")
      chaser.classList.remove("is-active")
    }
  });
}

const init = () => {
  w.load = {};
  w.load.mapScript = new $.Deferred;

  // map script
  const env_map_key = (/^local/.test(host)) ? 'AIzaSyDBB_DXqmoG89lUoaokvVH58OZbGj9bq0s' : 'AIzaSyDBB_DXqmoG89lUoaokvVH58OZbGj9bq0s';
  w.addScript({
    src: `https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`
  });

}

const documentLoaded = () => {

  const mvSlide = new Swiper('.mv_slide[data-plugin="mainSlider"]',{
    loop: true,
    effect: 'fade',
    speed: 1200,
    allowTouchMove: false,
    fadeEffect: {
      crossFade: false, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
    },
    autoplay:{
      delay: 4000,
      disableOnInteraction: false,
      waitForTransition: false
    },
    pagination: {
      el: ".mv-pager",
      clickable: true,
    },
  });

  let Mv = document.querySelector('.mainvisual');
  w.addEventListener('load', function() {
    Mv.classList.add('is-ready');
  });

  w.addScript({ src: 'https://www.youtube.com/iframe_api' });

  apply_movie();

  // map
  $.when(w.load['mapScript']).done(GOOGLEMAP);

  // マウス追従
  if( !mq.matches ) CursorFollower(5); //関数の使用

}


export default function HOME() {
  init();
  $(() => documentLoaded());
}